import { useState } from "react";
import HoverGallery from "@components/Features/HoverGallery/HoverGallery";
import { DeleteCompareOffer } from "@features/compare/DeleteCompareOffer";
import { RouterConfig } from "@shared/lib/routerConfig";
import { getCurrencySymbol } from "@shared/lib/utils";
import { LeftIcon } from "@shared/ui/Icon/ui/Common/LeftIcon";
import { RightIcon } from "@shared/ui/Icon/ui/Common/RightIcon";
import {
    CARD_TEXT_LINK,
    MAX_PAGE_NUMBER,
    MIN_PAGE_NUMBER,
    NEXT_TEXT_LABEL,
    PREV_TEXT_LABEL
} from "./constants";
import { ProductCardCompareProps } from "./types";
import classes from "./ProductCardCompare.module.scss";

export const ProductCardCompare = ({ offer, hideDeleteMode }: ProductCardCompareProps) => {
    const [currentPage, setCurrentPage] = useState(MIN_PAGE_NUMBER);
    const totalImages = offer.imagesList.filter((image) => image.small).length;
    const maxPages =
        totalImages < MIN_PAGE_NUMBER ? MIN_PAGE_NUMBER : Math.min(totalImages, MAX_PAGE_NUMBER);

    const formatPrice = `${offer.price.toLocaleString("ru-RU")} ${getCurrencySymbol(offer.sourceId)}`;

    const handlePrev = () => {
        setCurrentPage((prev) => (prev > 1 ? prev - 1 : MIN_PAGE_NUMBER));
    };

    const handleNext = () => {
        setCurrentPage((prev) => (prev < maxPages ? prev + 1 : maxPages));
    };

    return (
        <div className={classes["card-compare"]}>
            <HoverGallery
                offer={offer}
                pics={offer.imagesList}
                className={classes["card-compare__gallery"]}
                externalPage={currentPage}
            />
            {hideDeleteMode && (
                <DeleteCompareOffer
                    offerId={offer.id}
                    className={classes["card-compare__delete"]}
                />
            )}
            <div className={classes["card-compare__info"]}>
                <span className={classes["card-compare__title"]}>{offer.title}</span>
                <span className={classes["card-compare__price"]}>{formatPrice}</span>
                <a
                    href={`${RouterConfig.PRODUCT}/${offer.id}`}
                    className={classes["card-compare__link"]}
                >
                    {CARD_TEXT_LINK}
                </a>
                <div className={classes["card-compare__controls"]}>
                    <button
                        className={classes["card-compare__arrow"]}
                        aria-label={PREV_TEXT_LABEL}
                        onClick={handlePrev}
                    >
                        <LeftIcon className={classes["card-compare__arrow--color"]} />
                    </button>
                    <span className={classes["card-compare__count"]}>
                        {currentPage} из {maxPages}
                    </span>
                    <button
                        className={classes["card-compare__arrow"]}
                        aria-label={NEXT_TEXT_LABEL}
                        onClick={handleNext}
                    >
                        <RightIcon className={classes["card-compare__arrow--color"]} />
                    </button>
                </div>
            </div>
        </div>
    );
};